import React from 'react';
import {GoodsType} from "../../../../entities/goods/model/types/goods-type";
import styled from "styled-components";
import {StyledCard} from "./style";
import ProductPriceWrap from "../../../../shared/ui/price/ProductPriceWrap";
import ProductCurrentPrice from "../../../../shared/ui/price/ProductCurrentPrice";
import Badge from "../../../../shared/ui/badge/Badge";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";


interface IProps {
    goods: GoodsType,
    slotPreview: React.ReactNode,
    slotBasket: React.ReactNode,
}

const StyledRecommendCard = styled(StyledCard)`
    gap: 5px;
    padding: 10px 5px 5px 5px;
    border: 1px solid white;

    &:hover {
        box-shadow: 0 0 0 transparent;
        border: 1px solid ${props => props.theme.colors.lightBlue};
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('top-action')} {
        top: 5px;
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('slot-basket')} {
        button {
            padding: 3px 5px;

            svg {
                max-width: 18px;
            }
        }
    }

    // .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')} {
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: center;
    //     gap: 15px;
    // }


`
const StyledPreview = styled.div`

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-media-preview')} {
        text-align: center;

        img {
            max-height: 80px;
        }
    }
`

const RecommendCard: React.FC<IProps> = ({goods, slotBasket, slotPreview}) => {
    return (
        <StyledRecommendCard className={GLOBAL_STYLE_CONFIG.splitByPrefix('recommend-card')}>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-top-actions')}>
                <Badge type={'discount'} title={'-32%'}/>
            </div>
            <StyledPreview className={GLOBAL_STYLE_CONFIG.splitByPrefix('recommend-card-media')}>
                {slotPreview && slotPreview}
            </StyledPreview>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')}>
                <ProductPriceWrap className={"goods-price-wrap"}>
                    <ProductCurrentPrice>{goods.price} {goods.currency}</ProductCurrentPrice>
                </ProductPriceWrap>
                {slotBasket && (<div className={GLOBAL_STYLE_CONFIG.splitByPrefix('slot-basket')}>{slotBasket}</div>)}
            </div>
        </StyledRecommendCard>
    );
};

export default RecommendCard;